import Container from '@/components/container/Container';
import { CustomText } from '@/components/text/Texts';
import { Galleria } from 'primereact/galleria';
import '../../authentication-screens.styles.css';

const SignUpRightPanelCarousel = () => {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	const itemTemplate = (item: any) => {
		return (
			<Container className="relative w-[672px] h-[976px] overflow-hidden flex justify-center rounded-[28px]">
				<CustomText
					text={item.text}
					className="absolute w-full text-white text-[52px] font-poppins font-normal leading-[64px] z-10 p-6 transition-all transition-discrete "
				/>
				<img src={item.image} alt="" className="right-panel-image relative max-w-none" />
			</Container>
		);
	};

	const items = [
		{ image: '/images/sign-up-carousel/slide-1.jpg', text: 'Fleet Management Simplified' },
		{ image: '/images/sign-up-carousel/slide-2.jpg', text: 'Situational Awareness Summarized' },
		{ image: '/images/sign-up-carousel/slide-3.jpg', text: 'Supercharge your Business with Xpress' },
	];

	return (
		<Container className="sign-up-image-container">
			<Galleria
				autoPlay
				circular
				item={itemTemplate}
				showThumbnails={false}
				value={items}
				style={{ maxWidth: '672px' }}
				showIndicators
				transitionInterval={4000}
				pt={{ indicators: { className: 'indicators' }, indicator: { className: 'indicator' } }}
			/>
		</Container>
	);
};

export default SignUpRightPanelCarousel;
